import * as t from "io-ts";
import {LocationMetaPossibleDestinationCodec} from "./location-meta-possible-destination";

/** A recommendation with evidence, never confirmation that the driver is travelling to the site. */
export const LocationMetaDestinationRecommendationCodec = t.type({
  source: t.string,
  reasonCode: t.string,
  reason: t.string,
  policy: t.string,
  destination: LocationMetaPossibleDestinationCodec,
});
export type LocationMetaDestinationRecommendation = t.TypeOf<typeof LocationMetaDestinationRecommendationCodec>;
